function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8369 5.57975L12.5495 2.13956C12.3816 2.04674 12.1928 1.99805 12.0008 1.99805C11.8089 1.99805 11.6201 2.04674 11.4521 2.13956L5.16475 5.58118C4.9852 5.67942 4.83531 5.82407 4.73075 6.00002C4.62618 6.17597 4.57078 6.37676 4.57031 6.58144V13.4147C4.57078 13.6193 4.62618 13.8201 4.73075 13.9961C4.83531 14.172 4.9852 14.3167 5.16475 14.4149L11.4521 17.8565C11.6201 17.9494 11.8089 17.998 12.0008 17.998C12.1928 17.998 12.3816 17.9494 12.5495 17.8565L18.8369 14.4149C19.0165 14.3167 19.1664 14.172 19.2709 13.9961C19.3755 13.8201 19.4309 13.6193 19.4314 13.4147V6.58215C19.4313 6.37711 19.376 6.17587 19.2715 5.99951C19.1669 5.82315 19.0168 5.67816 18.8369 5.57975ZM12.0008 3.13982L17.7416 6.2835L15.6139 7.44738L9.87313 4.3037L12.0008 3.13982ZM12.0008 9.42718L6.26004 6.2835L8.68282 4.95673L14.4236 8.10041L12.0008 9.42718ZM18.2882 13.4175L12.5724 16.5462V10.4153L14.8587 9.16426V11.7135C14.8587 11.8651 14.9189 12.0105 15.0261 12.1177C15.1333 12.2249 15.2787 12.2851 15.4303 12.2851C15.5819 12.2851 15.7273 12.2249 15.8345 12.1177C15.9417 12.0105 16.0019 11.8651 16.0019 11.7135V8.53838L18.2882 7.28734V13.4147V13.4175Z",
  fill: "#085133"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 9.38281,
  y: 19.2891,
  width: 1,
  height: 4,
  rx: 0.5,
  fill: "#085133"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 15.3828,
  y: 19.2891,
  width: 1,
  height: 4,
  rx: 0.5,
  fill: "#085133"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 12.3828,
  y: 19.2891,
  width: 1,
  height: 3,
  rx: 0.5,
  fill: "#085133"
});

var SvgPackage = function SvgPackage(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPackage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Package.bbb742dc.svg";
export { ForwardRef as ReactComponent };